import { render, staticRenderFns } from "./QuickOptions.vue?vue&type=template&id=4ab2c661&scoped=true"
import script from "./QuickOptions.vue?vue&type=script&lang=js"
export * from "./QuickOptions.vue?vue&type=script&lang=js"
import style0 from "./QuickOptions.vue?vue&type=style&index=0&id=4ab2c661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab2c661",
  null
  
)

export default component.exports